import { gql } from '@apollo/client'

export const RESEND_EMAIL_QUESIONNAIRE = gql`
  mutation ResendEmailQuestionnaire($inputData: ResendEmailQuestionnaireInput!) {
    resendEmailQuestionnaire(inputData: $inputData)
  }
`
